import moment from 'moment';

export const generateDropDownOptions = (
  data = [],
  {
    valueProp = 'id',
    labelProp = 'name',
    fallbackLabelProp = 'displayName'
  } = {},
  withDefault = false
) => {
  const defaultOption = { name: '- None -', value: '' };
  if (!Array.isArray(data) || data.length === 0)
    return [withDefault ? defaultOption : {}];
  const options = data.map(item => ({
    value: item[valueProp] ?? '',
    name:
      item[labelProp] ||
      item[fallbackLabelProp] ||
      String(item[valueProp] ?? '')
  }));

  return withDefault ? [defaultOption, ...options] : options;
};

export const getTextByNestedOptions = (options = [], value) => {
  let list = [];
  options
    .filter(o => o.nestedOptions)
    .forEach(op => {
      list.push(...op.nestedOptions);
    });
  let filtered = list.filter(l => l.value === value);

  if (filtered.length) {
    return filtered[0].name;
  } else {
    return '';
  }
};

export const getDisplayDate = (
  date = '',
  fromFormat = 'DD-MM-YYYY',
  toFormat = 'MMM D, YYYY'
) => {
  return moment(date, fromFormat).format(toFormat);
};
